var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"back-btn-circle",attrs:{"dark":"","rounded":"","color":"primary"},on:{"click":_vm.click}},[_c('v-icon',[_vm._v("ico-back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }